import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon45: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#FFD147"
        d="M1.953 1.946a6.687 6.687 0 0 1 9.433.001c2.572 2.563 2.542 6.672.013 9.386-.075.08-.152.156-.236.23-.123.108-.063.061-.442.35-.579.438-.747.78-.747 2v.27a2.081 2.081 0 0 1 1.213 1.89v1.845c0 1.15-.936 2.082-2.089 2.082H4.261a2.086 2.086 0 0 1-2.09-2.082v-1.845c0-.83.488-1.547 1.194-1.88l.001-.28c0-1.22-.168-1.562-.747-2-.379-.289-.319-.242-.442-.35a3.15 3.15 0 0 1-.224-.216 6.633 6.633 0 0 1 0-9.4Zm7.145 13.042H4.261c-.602 0-1.09.486-1.09 1.085v1.845c0 .6.488 1.085 1.09 1.085h4.837c.601 0 1.089-.485 1.089-1.085v-1.845c0-.599-.488-1.085-1.089-1.085Zm1.581-12.337a5.686 5.686 0 0 0-8.019 0 5.643 5.643 0 0 0 .013 8.004c.051.055.106.107.165.16.096.084.041.042.387.304.828.628 1.141 1.263 1.141 2.794l-.001.078H6.17l.001-3.852-1.612-2.678a.496.496 0 0 1 .171-.683.5.5 0 0 1 .686.171L6.67 9.03l1.254-2.08a.5.5 0 0 1 .605-.21l.081.038a.496.496 0 0 1 .171.683L7.17 10.136v3.855h1.803l.001-.078c0-1.446.279-2.093 1.008-2.689l.133-.105c.345-.262.291-.22.386-.304.06-.053.114-.105.166-.16 2.17-2.329 2.196-5.828.012-8.004Z"
      />
    </Svg>
  )
}
